import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import Util from '../../../shared/util/util';
import Person from '../../../shared/components/person/person';
import LockedIcon from '../../../../images/integrations/locked_icon';
import {profilePicSrc} from '../../../../directApi';

type ExpenseRow = {
	id: string;
	name: string;
	category: {name: string} | null;
	isLocked: boolean;
	expenseYear: number;
	expenseMonth: number;
	expenseDay: number;
	quantity: number;
	price: number | null;
	person: {fullName: string; profilePictureId?: number | null} | null;
};

type Props = {
	expenses: ExpenseRow[];
	currencySymbol: string;
};

const ProjectRetainerPeriodExpensesTable: React.FC<Props> = ({expenses, currencySymbol}) => {
	const {formatMessage} = useIntl();
	const [collapsed, setCollapsed] = useState(true);

	return (
		<div className={'retainer-expense-table-wrapper'}>
			<div className={'table-expand-bar'} onClick={() => setCollapsed(c => !c)}>
				<div className={'bar-title'}>{formatMessage({id: 'retainer.see_expenses'})}</div>
				<div className={'expand-icon' + (collapsed ? ' collapsed' : '')} />
			</div>
			{!collapsed && (
				<table>
					<thead>
						<tr>
							<th>{formatMessage({id: 'expense_management.expense_name'})}</th>
							<th>{formatMessage({id: 'expense_management.column.category'})}</th>
							<th>{formatMessage({id: 'common.locked_entry'})}</th>
							<th>{formatMessage({id: 'common.date'})}</th>
							<th className={'num'}>{formatMessage({id: 'common.quantity'})}</th>
							<th className={'num'}>{formatMessage({id: 'common.price'})}</th>
							<th>{formatMessage({id: 'common.person'})}</th>
						</tr>
					</thead>
					<tbody>
						{expenses.map(expense => {
							const date = Util.CreateNonUtcMomentDate(
								expense.expenseYear,
								expense.expenseMonth,
								expense.expenseDay
							);
							return (
								<tr key={expense.id}>
									<td>{expense.name}</td>
									<td>{expense.category?.name ?? '—'}</td>
									<td>
										{expense.isLocked ? (
											<LockedIcon
												width={14}
												height={13}
												fill="#a1a1a1"
												className="status-icon"
												title={formatMessage({id: 'common.locked_entry'})}
											/>
										) : null}
									</td>
									<td>{date ? date.format('DD MMM') : '—'}</td>
									<td className={'num'}>{expense.quantity}</td>
									<td className={'num'}>
										{expense.price != null
											? Util.getFormattedCurrencyValue(currencySymbol, expense.price, false, false, true)
											: '—'}
									</td>
									<td>
										{expense.person ? (
											<Person
												key={expense.id}
												name={expense.person.fullName}
												role={''}
												showName={true}
												imageSrc={profilePicSrc(expense.person.profilePictureId)}
												imageSize="medium"
												showRole={false}
											/>
										) : (
											'—'
										)}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			)}
		</div>
	);
};

export default ProjectRetainerPeriodExpensesTable;
